import { render, staticRenderFns } from "./LeaveConfirmationModal.vue?vue&type=template&id=9670327e&scoped=true&"
import script from "./LeaveConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./LeaveConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9670327e",
  null
  
)

export default component.exports